import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class I18nInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    let authReq: HttpRequest<unknown>;
    if (req.url.startsWith('/i18n/')) {
      authReq = req.clone({
        url: req.url,
        headers: req.headers
          .set('Accept', 'application/json')
          .set('Content-Type', 'application/x-www-form-urlencoded'),
      });
    }

    return next.handle(authReq || req);
  }
}
